function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.29855 22V3H14.1477C16.8903 3 19.1136 5.22331 19.1136 7.96591V7.96591C19.1136 10.7085 16.8903 12.9318 14.1477 12.9318H4",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 17.25H15.2273",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgRuble = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRuble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Ruble.183d0c7a.svg";
export { ForwardRef as ReactComponent };